export default "__VITE_ASSET__c96bc8bf__"